import React, {Component} from "react"
import DatePicker from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css"

export default class FieldDate extends Component {
  constructor(props) {
    super(props)
    this.state = {value: this.props.value}
  }

  onChange(date) {
    let date_formatted = date && date.format("YYYY-MM-DD")
    this.setState({
      value: date
    })
    if (this.props.onValueChange) {
      this.props.onValueChange(this.props.name, date_formatted)
    }
    if (this.props.onChange) {
      this.props.onChange(date_formatted)
    }
  }

  render() {
    return (
      <label style={{width: this.props.width || 120}}>
        <span>{this.props.label}</span>
        <DatePicker
          selected={this.state.value || this.props.defaultValue}
          onChange={this.onChange.bind(this)}
          dateFormat="DD.MM.YYYY"
          locale="de-de"
        />
        {this.renderError()}
      </label>
    )
  }

  renderError() {
    if (!this.props.getError) {
      return null
    }

    let error = this.props.getError(this.props.name)
    if (error) {
      return <span className="error">{error}</span>
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/fields/FieldDate.js